export default class RoutingPaths {
  static INDEX = "/";
  static LOGIN = "/login";
  static DASHBOARD = "/dashboard";
}
